import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlGridOneColProps, AtlGridTagNames } from './grid.props';
import classNames from 'classnames';
import { getGlobalStyleSheets } from '../../global-styles';

@customElement(AtlGridTagNames.GridOneCol)
export class AtlGridOneCol extends LitElement implements AtlGridOneColProps {
   declare internalId: string;
   declare internalClassName?: string;
   declare internalColClassName?: string;

   static properties = {
      internalId: { type: String },
      internalClassName: { type: String },
      internalColClassName: { type: String },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      return html`
         <div
            id=${this.internalId}
            class=${classNames('row', 'grid-one-col', this.internalClassName)}
         >
            <div class=${classNames('col-md-12', this.internalColClassName)}>
               <slot></slot>
            </div>
         </div>
      `;
   }
}
